<div class="card-wrapper">
  <div class="headline">
    Artikel hinzufügen –
    @if (activeTab() === 'quickorder') {
      Schnellerfassung
    } @else {
      Artikelsuche
    }
  </div>

  <mat-tab-group
    [selectedIndex]="selectedTabIndex()"
    (selectedIndexChange)="selectTab($event)"
    mat-stretch-tabs="false"
    mat-align-tabs="start"
    animationDuration="200ms"
    class="custom-tabs"
    dynamicHeight
  >
    <mat-tab>
      <ng-template mat-tab-label>
        <div class="custom-tab-label">
          <ui-icon class="tab-icon" faName="list-check" faStyle="light"></ui-icon>
          <span class="tab-text">Schnellerfassung</span>
        </div>
      </ng-template>

      <div class="tab-content">
        <ui-form-textarea
          [data]="searchInputConfigMultiple"
          [formControl]="collectionSearchControl">
        </ui-form-textarea>
        <p class="hint-text">Eine Nummer inkl. Mengenangabe pro Zeile - Trennung auch per Komma oder Semikolon möglich</p>
        <div class="buttons">
          <ui-button buttonStyle="outlined" (click)="addToQuickOrderList()">
            Artikel hinzufügen
          </ui-button>
        </div>
      </div>
    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>
        <div class="custom-tab-label">
          <ui-icon class="tab-icon" faName="magnifying-glass" faStyle="light"></ui-icon>
          <span class="tab-text">Artikelsuche</span>
        </div>
      </ng-template>

      <div class="tab-content">
        <ui-search-suggestion-autocomplete
          [data]="searchInputConfig"
          [formControl]="searchControl">
        </ui-search-suggestion-autocomplete>

        <ui-form-number
          [data]="productQuantityInputConfig"
          [formControl]="quantityControl">
        </ui-form-number>
        <div class="buttons">
          <ui-button buttonStyle="outlined" (click)="addToQuickOrderList()">
            Artikel hinzufügen
          </ui-button>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
